// extracted by mini-css-extract-plugin
export default {"rightPane":"RightPane_rightPane__ekGob","selectGenreButton":"RightPane_selectGenreButton__MfDvD","attributesContainer":"RightPane_attributesContainer__YFtrS"};